export default __webpack_public_path__ + "static/media/jackie-paper.83230750.png";